import { useMemo } from 'react'
import { marked } from 'marked'
import { sanitize } from '~/shared/xss'
import { MarkdownProps } from '~/app/components/Markdown/interface'
import getLogger from '~/shared/logger'

export const Markdown = ({ options, children }: MarkdownProps) => {
  const safeHtml = useMemo(() => {
    try {
      return sanitize(marked.parse(children, options) as string)
    } catch (error) {
      getLogger().warn('Failed to parse markdown:', error)
      return ''
    }
  }, [children, options])

  return <div className="markdown-body" dangerouslySetInnerHTML={{ __html: safeHtml }} />
}
